<template>
  <div>
    <np-action-btn
      class="float-right"
      :disabled="disabled"
      @click="showDialog = true"
    >
      More Layers
    </np-action-btn>
    <LayerDialog
      :show-dialog="showDialog"
      @close="showDialog = false"
    />
  </div>
</template>

<script>
import LayerDialog from './LayerDialog.vue';

export default {
  name: 'LayerCatalog',
  components: {
    LayerDialog,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
};
</script>
